import { render } from "./MessengerBotEditorCmp.vue?vue&type=template&id=3258d028"
import script from "./MessengerBotEditorCmp.vue?vue&type=script&lang=js"
export * from "./MessengerBotEditorCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__